// BRO-877: Sentry browser SDK init must come BEFORE any other code that
// could throw, so render-time crashes during the first paint are
// capturable. DSN-gated: missing env var = silent no-op (dev convenience).
import * as Sentry from '@sentry/react';
import { scrubEvent } from './utils/piiScrubber';

const sentryDsn = import.meta.env.VITE_GLITCHTIP_DSN_BROWSER;
const appEnv = window.APP_ENV || import.meta.env.MODE;
// BRO-877 follow-up: never report from local/dev environments — those
// errors are dev noise, not real-user data, and they pollute the GlitchTip
// dashboard we use to triage production incidents. Belt-and-braces with
// the DSN-gate above so a stale local .env can't silently start reporting.
const isLocalEnv = appEnv === 'local' || appEnv === 'development';
if (sentryDsn && !isLocalEnv) {
    Sentry.init({
        dsn: sentryDsn,
        // BRO-877 phase 6: Tunnel envelopes through our own domain so
        // ad-blockers (uBlock, AdGuard, etc.) and corporate proxies that
        // block telemetry endpoints don't silently drop events. The relay
        // server-side forwards verbatim to GlitchTip after validating the
        // envelope's DSN matches our configured browser project.
        tunnel: '/api/error-relay',
        release: window.APP_VERSION || 'unknown',
        environment: appEnv,
        sampleRate: 1.0,             // 100% of errors (design D8)
        tracesSampleRate: 0,         // no traces in v1 (design D8)
        replaysSessionSampleRate: 0, // no replay (design D8)
        replaysOnErrorSampleRate: 0,
        beforeSend: scrubEvent,
    });

    // User context — read from window.* vars set by Blade layout.
    if (window.userId) {
        Sentry.setUser({
            id: String(window.userId),
            email: window.userEmail || undefined,
        });
    }
    if (window.companyId) {
        Sentry.setTag('company_id', String(window.companyId));
    }
}

import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Initialize CSRF token handling with auto-refresh
import { initializeCsrfHandling } from './axios-config';
initializeCsrfHandling();

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allow your team to quickly build robust real-time web applications.
 */

import './echo';
